import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyEnum } from '../../models/company.model';
import { COMPANY_LOGO_PATH_PREFIX } from '../../utils/constant';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lx-price-lists-portal-error-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  companyLogoPath = `${COMPANY_LOGO_PATH_PREFIX}${CompanyEnum.KIL}.svg`;
  forbidden = false;
  attemptedUrl: string | undefined;

  private readonly route = inject(ActivatedRoute);

  ngOnInit() {
    this.forbidden = this.route.snapshot.data.forbidden ?? false;
    this.attemptedUrl = history.state?.attemptedUrl;
  }
}
